module.exports = __webpack_public_path__ + "img/word.4817701a.svg";